import React, { useEffect, useState } from "react";
import { Sparkles, TrendingUp, TrendingDown } from "lucide-react";
import api from "@/lib/api";

export default function AIInsightsCard() {
  const [insights, setInsights] = useState(null);

  useEffect(() => {
    api.get("/users/me/insights").then((res) => setInsights(res.data)).catch(() => {});
  }, []);

  if (!insights) return null;

  return (
    <div className="glass-panel rounded-2xl p-6 transition-all duration-300 ease-out hover:-translate-y-1 hover:border-white/20 hover:shadow-[0_12px_40px_rgba(0,0,0,0.35)]" data-testid="ai-insights-card">
      <span className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400 flex items-center gap-2">
        <span className="w-6 h-6 rounded-md bg-indigo-400/10 flex items-center justify-center"><Sparkles className="w-3.5 h-3.5 text-indigo-400" /></span> AI Learning Insights
      </span>
      <p className="text-sm text-slate-300 leading-relaxed mt-3" data-testid="ai-insights-recommendation">
        {insights.recommendation}
      </p>
      {insights.has_data && (
        <div className="flex flex-wrap gap-4 mt-4 pt-4 border-t border-white/[0.06]">
          {insights.weak_topics.length > 0 && (
            <div className="flex-1 min-w-[140px]">
              <p className="text-[10px] font-bold uppercase tracking-wider text-indigo-400 flex items-center gap-1 mb-2">
                <TrendingDown className="w-3 h-3" /> Focus Areas
              </p>
              {insights.weak_topics.map((t) => (
                <p key={t.day} className="text-xs text-slate-400 mb-1">Day {t.day}: {t.title} ({t.score}%)</p>
              ))}
            </div>
          )}
          {insights.strong_topics.length > 0 && (
            <div className="flex-1 min-w-[140px]">
              <p className="text-[10px] font-bold uppercase tracking-wider text-emerald-400 flex items-center gap-1 mb-2">
                <TrendingUp className="w-3 h-3" /> Strengths
              </p>
              {insights.strong_topics.map((t) => (
                <p key={t.day} className="text-xs text-slate-400 mb-1">Day {t.day}: {t.title} ({t.score}%)</p>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
